module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Adam Azanow-b4584238b85d931e925a5036653f8914.jpg";